export enum PaymentMethodTypesEnum {
  BANK_CARD = 'BANK_CARD',
  APPLE_PAY = 'APPLE_PAY',
  GOOGLE_PAY = 'GOOGLE_PAY',
  YOO_MONEY = 'YOO_MONEY',
  SBERBANK = 'SBERBANK',
}
